import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Header = ({ project, quote, backRoute }) => (
  <div className="px-8 pt-6 pb-4 bg-white border-b border-slate-200">
    <div className="flex items-center gap-2 text-[12.5px] text-slate-500 mb-3">
      <a href={backRoute} className="hover:text-slate-900 inline-flex items-center gap-1.5">
        <FontAwesomeIcon icon="arrow-left" />
        {I18n.t("projects.situations.back_to_project")}
      </a>
      <span>·</span>
      <span className="text-slate-700">{project.name}</span>
      {project.code && <span className="text-slate-400 tabular-nums">{project.code}</span>}
    </div>

    <div className="flex items-start justify-between gap-6 flex-wrap">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold text-slate-900 m-0">
          {I18n.t("projects.situations.title")}
        </h1>
        {quote && (
          <p className="text-sm text-slate-500 mt-1">
            {I18n.t("projects.situations.based_on_quote", { number: quote.number || "—", title: quote.title || "" })}
          </p>
        )}
      </div>
    </div>
  </div>
)

export default Header
